module.exports = __webpack_public_path__ + "static/media/review-logo.9a743808.svg";